// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3wAru","unreadBadge":"styles_unreadBadge__zebYZ","modalContent":"styles_modalContent__1LwWN","modal":"styles_modal__1h_kP"};